import { createSlice } from '@reduxjs/toolkit';
import request from '../../service';
import Exported from '../../service/endpoints';
import config from '../../service/env';

const initialState = {
  microAppList: [],
  recentActivity: {},
  locationData: [],
  collectionData: [],
  organisationData: [],
  currentPillar: null,
  currentModule: null,
};
export const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    saveMicroAppList: (state, action) => {
      state.microAppList = action.payload;
    },
    saveRecentActivity: (state, action) => {
      state.recentActivity = action.payload;
    },
    setLocationData: (state, action) => {
      state.locationData = action.payload;
    },
    setCollectionData: (state, action) => {
      state.collectionData = action.payload;
    },
    setOrganisationData: (state, action) => {
      state.organisationData = action.payload;
    },
    setCurrentPillar: (state, action) => {
      state.currentPillar = action.payload;
    },
    setCurrentModule: (state, action) => {
      state.currentModule = action.payload;
    },
  },
});

export const uploadfile = (data) => {
  return request({
    url: Exported.Endpoints.uploadfile,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.documentServiceApi,
  });
};

export const getLookUpApi = (data) => {
  const queryString = Object.keys(data).length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.getLookup + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.identityServiceApi,
  });
};

export const {
  setLocationData,
  setCollectionData,
  setOrganisationData,
  setCurrentPillar,
  setCurrentModule,
} = adminSlice.actions;

export const locationData = (state) => state.admin.locationData;
export const collectionData = (state) => state.admin.collectionData;
export const organisationData = (state) => state.admin.organisationData;
export const currentPillar = (state) => state.admin.currentPillar;
export const currentModule = (state) => state.admin.currentModule;

export const createRole = (data) => {
  return request({
    url: Exported.Endpoints.createRole,
    method: Exported.APIMethods.POST,
    data,
  });
};

export const patchRole = (id, data) => {
  return request({
    url: Exported.Endpoints.patchRole + id,
    method: Exported.APIMethods.PUT,
    data,
  });
};
